import epsLogo from "assets/img/eps.svg";
import PropTypes from "prop-types";
import throttle from "lodash/throttle";
import isFunction from "lodash/isFunction";
import Router from "next/router";
import sofortLogo from "assets/img/klarna.svg";
import masterLogo from "assets/img/master.svg";
import visaLogo from "assets/img/visa.svg";
import paypalLogo from "assets/img/paypal.png";
import {
  Error,
  Loading,
  PaymentShortSummary,
  VoucherOrDiscount,
} from "components";
import messages from "i18n/messages";
import classNames from "classnames";
import flowRight from "lodash/flowRight";
import isEmpty from "lodash/isEmpty";
import { makeSelectCustomer } from "logic/customers";
import { makeSelectCurOrder } from "logic/orders";
import { makeSelectCurOrg } from "logic/orgs";
import {
  makeSelectError,
  makeSelectPaymentData,
  updatePaymentDataAttr,
  checkVoucherCode,
  checkPromoCode,
  makeSelectLoading,
  makeSelectCodeError,
} from "logic/payment";
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import { createStructuredSelector } from "reselect";

const loadPSPScript = (checkoutId, env) => {
  const curScript = document.getElementById("psp-script");
  if (window.wpwl && isFunction(window.wpwl.unload)) window.wpwl.unload();
  if (curScript) curScript.remove();
  const head = document.getElementsByTagName("head")[0];
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.setAttribute("id", "psp-script");
  script.src = `${process.env.PSP_SCRIPT_URI}?checkoutId=${checkoutId}`;
  head.appendChild(script);
};

class MeteorPaymentForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
  };

  state = {
    showForm: true,
    sendAdditionalContactInfoToPSP: true,
    loading: false,
    hostname: "shop.ticketteer.com",
  };

  componentDidMount() {
    this.updatePaymentForm();
    this.setState(
      { hostname: `${window.location.protocol}//${window.location.host}` },
      this.aquire
    );
  }

  updatePaymentForm() {
    window.wpwlOptions = {
      locale: this.props.intl.locale,
      autoStart: false,
      sofortCountries: {
        AT: "Österreich",
        DE: "Deutschland",
        NL: "Nederland",
        BE: "Belgique",
        CH: "Schweiz",
        GB: "United Kingdom",
      },
      mandatoryBillingFields: {},
      style: "plain",
      forceCardHolderEqualsBillingName: false,
      showCVVHint: true,
      brandDetection: true,
      onReady: this.formReady,
    };
  }

  aquire = () => {
    if (
      !this.props.paymentData ||
      this.props.paymentData.checkout_id === this.checkoutId
    )
      return;
    if (this.checkoutId) {
      location.reload();
      return;
    }

    this.checkoutId = this.props.paymentData.checkout_id;
    if (this.props.paymentData.value <= 0) return;

    loadPSPScript(this.props.paymentData.checkout_id, this.props.env);
  };

  componentDidUpdate() {
    const curScript = document.getElementById("psp-script");
    if (curScript) {
      this.aquire();
      return;
    }
    throttle(this.aquire, 2000);
  }

  formReady = () => {
    const { paymentData } = this.props;
    this.setCardHolder();
    if (this.state.sendAdditionalContactInfoToPSP) {
      [
        "email",
        "street",
        "street2",
        "city",
        "postcode",
        "country_code",
      ].forEach((key) => this.getHiddenPsd2InputField(key));
    }
    const div = document.getElementsByClassName("wpwl-brand wpwl-brand-PAYPAL");
    let value = this.props.intl.formatNumber(paymentData.value / 100.0, {
      style: "currency",
      currency: "EUR",
    });

    if (div && div.length > 0)
      div[0].innerText = this.props.intl.formatMessage(
        messages.continueToPayPal
      );
    const btn = document.getElementsByClassName("wpwl-button-pay");
    btn[0].innerText = `${btn[0].innerText} (${value})`;
    this.setState({ loading: false });
  };

  setCardHolder = () => {
    const { customer } = this.props;
    const cardHolderEl = document.querySelector(".wpwl-control-cardHolder");
    cardHolderEl.value = `${customer.firstname} ${customer.lastname}`;
  };

  getHiddenPsd2InputField = (key) => {
    const { customer } = this.props;
    if (!customer[key] || isEmpty(customer[key])) return;

    let html;
    if (key === "email") {
      html = `<input type="hidden" name="customer.email" value="${customer.email}" />`;
    } else if (key === "street") {
      html = `<input type="hidden" name="billing.street1" value="${customer.street}" />`;
    } else if (key === "country_code") {
      html = `<input type="hidden" name="billing.country" value="${customer.country_code}" />`;
    } else {
      html = `<input type="hidden" name="billing.${key}" value="${customer[key]}" />`;
    }
    document
      .querySelector(".wpwl-button-pay")
      .insertAdjacentHTML("afterend", html);
  };

  // showForm = (cnpApi) => this.setState({ showForm: true })

  handleTogglePaymentMethod = ({ target }) =>
    this.props.actions.updatePaymentDataAttr("payment_method", target.value);

  handleSubmitZeroPayment = () =>
    this.setState({ loading: true }, () =>
      Router.push(
        `/${this.props.org.odn}/status/${this.props.paymentData.checkout_id}`
      )
    );

  getPaymentMethod = () =>
    this.props.paymentData.payment_method || "creditcard";

  pspMethods = () =>
    this.props.org.psp_methods
      .map((m) => (m === "card" ? "VISA MASTER" : m.toUpperCase()))
      .join(" ");

  render() {
    const {
      paymentData,
      donation,
      customer,
      error,
      org,
      order,
      values,
      deliveryMethod,
      payable,
      date,
    } = this.props;

    if (error) return <Error error={error} prefix="payment" />;
    if (!order && !values) return <></>;
    if (!paymentData) return <></>;

    const redirectUrl = `${this.state.hostname}/${org.odn}/status?payid=${paymentData.checkout_id}`;
    return (
      <div className={`payment-form ${this.props.hide ? "hidden" : ""}`}>
        <h2>
          <FormattedMessage {...messages.paymentMethod} />
        </h2>
        <Row className="align-items-stretch">
          <Col lg={8}>
            {paymentData && paymentData.value > 0 ? (
              <>
                <div
                  className={classNames("select-payment-method-radios", {
                    "four-items": org.psp_methods.length > 3,
                  })}
                >
                  {!org.psp_methods ||
                  org.psp_methods.length < 1 ||
                  org.psp_methods.includes("card") ? (
                    <FormGroup check className="form-check-radio">
                      <Label check>
                        <Input
                          type="radio"
                          name="payment_method"
                          value="creditcard"
                          checked={this.getPaymentMethod() === "creditcard"}
                          onChange={this.handleTogglePaymentMethod}
                        />
                        <span className="form-check-sign" />
                        <div className="creditcard-icons">
                          <img src={visaLogo} alt="" />
                          <img src={masterLogo} alt="" />
                        </div>
                        <div className="desc">
                          <FormattedMessage {...messages.creditCard} />
                        </div>
                      </Label>
                    </FormGroup>
                  ) : null}
                  {org.psp_methods.includes("paypal") ? (
                    <FormGroup check className="form-check-radio">
                      <Label check>
                        <Input
                          type="radio"
                          name="payment_method"
                          value="paypal"
                          checked={this.getPaymentMethod() === "paypal"}
                          onChange={this.handleTogglePaymentMethod}
                        />
                        <span className="form-check-sign" />
                        <img src={paypalLogo} alt="" className="paypal-logo" />
                        <br />
                        <div className="desc">
                          <FormattedMessage {...messages.paypal} />
                        </div>
                      </Label>
                    </FormGroup>
                  ) : null}
                  {org.name.toUpperCase().includes("SIMPL") ||
                  (org.psp_methods && org.psp_methods.includes("eps")) ? (
                    <FormGroup check className="form-check-radio">
                      <Label check>
                        <Input
                          type="radio"
                          name="payment_method"
                          value="eps"
                          checked={this.getPaymentMethod() === "eps"}
                          onChange={this.handleTogglePaymentMethod}
                        />
                        <span className="form-check-sign" />
                        <img src={epsLogo} alt="" className="eps-logo" />
                        <br />
                        <div className="desc">
                          <FormattedMessage {...messages.eps} />
                        </div>
                      </Label>
                    </FormGroup>
                  ) : null}
                  {!org.psp_methods ||
                  org.psp_methods.length < 1 ||
                  org.psp_methods.includes("sofort") ? (
                    <FormGroup check className="form-check-radio">
                      <Label check>
                        <Input
                          type="radio"
                          name="payment_method"
                          value="sofort"
                          checked={this.getPaymentMethod() === "sofort"}
                          onChange={this.handleTogglePaymentMethod}
                        />
                        <span className="form-check-sign" />
                        <img src={sofortLogo} alt="" className="sofort-logo" />
                        <br />
                        <div className="desc">
                          <FormattedMessage {...messages.sofortKlarna} />
                        </div>
                      </Label>
                    </FormGroup>
                  ) : null}
                </div>
                <h2>
                  <FormattedMessage {...messages.paymentDetails} />
                </h2>
                <div
                  className={`payment-form-body pay-${this.getPaymentMethod()}`}
                >
                  <form
                    action={redirectUrl}
                    className="paymentWidgets"
                    data-brands={this.pspMethods()}
                  />
                  <div className="d-block-xs d-none">
                    {((org.portal && org.portal.vouchers_enabled) ||
                      (date && date.discounts_enabled)) &&
                    payable.id.includes("ord_") &&
                    !payable.voucher_id ? (
                      <VoucherOrDiscount
                        {...this.props.actions}
                        loading={this.props.loading}
                        codeError={this.props.codeError}
                      />
                    ) : null}
                  </div>
                  {deliveryMethod !== "post" ||
                  (customer.street &&
                    customer.postcode &&
                    customer.city &&
                    customer.country_code) ? null : (
                    <div className="alert-overlay">
                      <div className="alert-message">
                        <FormattedMessage {...messages.noShippingAddrGiven} />
                      </div>
                    </div>
                  )}
                </div>
              </>
            ) : null}
            {paymentData && paymentData.value === 0 ? (
              <div className="congrats-wrap">
                <p className="congrats-text mb-4 text-center">
                  <FormattedMessage {...messages.nothingLeftToPay} />
                </p>
                <Button
                  color="success"
                  block
                  disabled={this.props.loading || this.state.loading}
                  onClick={this.handleSubmitZeroPayment}
                >
                  {this.props.loading || this.state.loading ? (
                    <Loading color="white" width="1.5em" />
                  ) : (
                    <FormattedMessage {...messages.receiveTickets} />
                  )}
                </Button>
              </div>
            ) : null}
          </Col>
          <Col lg={4}>
            <PaymentShortSummary
              values={values || order.seats}
              payable={payable}
              date={date}
              donation={donation}
              paymentData={paymentData}
              handleSubmit={this.props.handleSubmit}
              deliveryMethod={deliveryMethod || order.delivery_method}
            />
          </Col>
          {/*
          <FormGroup check className="payment-psd2-checkbox">
            <Label check>
              <Input
                type="checkbox"
                checked={this.state.sendAdditionalContactInfoToPSP}
                onChange={this.handleToggleRegisterNew}
              />
              <span className="form-check-sign" />
              <FormattedMessage {...messages.sendAdditionalDataToPSP} />
            </Label>
            <FormText><FormattedMessage {...messages.sendAdditionalDataToPSPDesc} /></FormText>
          </FormGroup>
          */}
        </Row>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  paymentData: makeSelectPaymentData(),
  customer: makeSelectCustomer(),
  order: makeSelectCurOrder(),
  org: makeSelectCurOrg(),
  error: makeSelectError(),
  codeError: makeSelectCodeError(),
  loading: makeSelectLoading(),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      updatePaymentDataAttr,
      checkVoucherCode,
      checkPromoCode,
    },
    dispatch
  ),
});

const enhance = flowRight(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
);
export default enhance(MeteorPaymentForm);
